import React from "react";
import UploadComponent from "./UploadComponent";
import "./MainContent.css";

interface MainContentProps {
  prompt?: string;
  model?: string;
  compareMode?: boolean;
  modelA?: string;
  modelB?: string;
}

const MainContent: React.FC<MainContentProps> = ({ prompt, model, compareMode = false, modelA = "breeze", modelB = "breeze" }) => {
  const containerClass = compareMode ? "compare-center-content" : "upload-center-content";
  return (
    <div className="main-content-container">
      <div className={containerClass}>
        <UploadComponent
          prompt={prompt}
          model={model}
          compareMode={compareMode}
          modelA={modelA}
          modelB={modelB}
        />
      </div>
    </div>
  );
};

export default MainContent;
